import { useEffect, useState } from "react";
import api, { formatApiError } from "@/utils/api";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { Mail } from "lucide-react";

// Per-person override: opted-in learners/students get emails even while the master switch is off.
export const EmailOptInToggle = ({ url, value, name, onChanged, canEdit = true }) => {
  const [on, setOn] = useState(!!value);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setOn(!!value); }, [value]);
  const toggle = async (v) => {
    setBusy(true);
    try { await api.put(url, { opt_in: v }); setOn(v); toast.success(v ? `${name} will receive emails` : `${name} opted out of emails`); onChanged?.(v); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail) || "Couldn't update"); }
    finally { setBusy(false); }
  };
  return (
    <div className="flex items-center justify-between gap-3 rounded-lg border border-border px-3 py-2" data-testid="email-opt-in-row">
      <div className="flex items-start gap-2">
        <Mail size={14} className={`mt-0.5 ${on ? "text-green-700" : "text-slate-400"}`} />
        <div>
          <p className="text-xs font-semibold">Receives emails</p>
          <p className="text-[11px] text-muted-foreground">{on ? "Gets learner emails even while they're switched off for everyone (payment emails stay off)." : "Follows the app-wide Learner emails setting."}</p>
        </div>
      </div>
      <Switch checked={on} disabled={busy || !canEdit} onCheckedChange={toggle} data-testid="email-opt-in-switch" />
    </div>
  );
};
